import type { Feature, Geometry } from "geojson";

/**
 * Mutates feature by adding value to property
 * @param feature geojson feature
 * @param value value to be added to properties under key "value"
 * @returns
 */
export const addValueToFeature = (
  feature: Feature<Geometry>,
  // Value is unknown, as we don't wan't to limit system to just single type
  value: unknown,
): Feature<Geometry> => {
  // Mutation over creating new object to increase performance
  feature.properties = { ...feature.properties, value };
  return feature;
};

/**
 * Mutates feature by adding multiple values directly to properties
 * Unlike `addValueToFeature`, this does NOT wrap values in a "value" object.
 * Instead, it adds them as separate properties like "value-1", "value-2", ...
 *
 * @param feature GeoJSON feature
 * @param values Key-value pairs to be added directly to feature properties
 * @returns Mutated feature with additional properties
 */
export const addMultipleValuesToFeature = (
  feature: Feature<Geometry>,
  values: Record<string, unknown>, // Supports multiple values
): Feature<Geometry> => {
  // Merge new values directly into properties
  feature.properties = { ...feature.properties, ...values };
  return feature;
};
